import React, { useCallback } from 'react';
import MenuCard from './MenuCard';
import { resolveSelectedVariant } from '../services/tableService';
import type { SearchResult, Variant, CartItem, TableCart, VariantMap, FoodItem } from '../types';

export interface SearchResultsGridProps {
    results: SearchResult[];
    tableCart: TableCart;
    variantMap: VariantMap;
    onAddToCart: (item: FoodItem, category: string, name: string) => void;
    onUpdateQty: (key: string, val: CartItem, delta: number) => void;
    onVariantChange: (compositeKey: string, variant: Variant) => void;
}

const SearchResultsGrid: React.FC<SearchResultsGridProps> = ({
    results,
    tableCart,
    variantMap,
    onAddToCart,
    onUpdateQty,
    onVariantChange,
}) => {
    const renderResult = useCallback(
        (sr: SearchResult) => {
            const { category, itemKey, item } = sr;
            const compositeKey = `${category}-${itemKey}`;
            const selVar = resolveSelectedVariant(variantMap, compositeKey, item);
            const cartKey = `${compositeKey}-${selVar.value}`;
            const cartItem = tableCart[cartKey] as CartItem | null;
            const inCartQty = cartItem?.selected || 0;

            return (
                <MenuCard
                    key={`search-${category}-${itemKey}`}
                    item={item}
                    category={category}
                    name={itemKey}
                    selectedVariant={selVar}
                    inCartQty={inCartQty}
                    onAdd={() => onAddToCart(item, category, itemKey)}
                    onIncrement={() => cartItem && onUpdateQty(cartKey, cartItem, 1)}
                    onDecrement={() => cartItem && onUpdateQty(cartKey, cartItem, -1)}
                    onVariantChange={(v: Variant) => onVariantChange(compositeKey, v)}
                />
            );
        },
        [tableCart, variantMap, onAddToCart, onUpdateQty, onVariantChange],
    );

    if (results.length === 0) {
        return null;
    }

    return (
        <div className="posv2-menu-grid">
            {results.map(renderResult)}
        </div>
    );
};

export default React.memo(SearchResultsGrid);
